import ICasRenderCellProps from '../ICasRenderCellProps';
import getCasTableCellValue from '../getCasTableCellValue';

export function CasRenderTruncatedText(props: ICasRenderCellProps) {
  const value = getCasTableCellValue(props);

  return <div style={{ maxHeight: '3.2rem', overflowY: 'auto' }}>{value}</div>;
}
